"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Layout = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Masthead_1 = require("../Masthead/Masthead");
function Layout({ children, masthead }) {
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "grid grid-rows-layout h-full" }, { children: [(0, jsx_runtime_1.jsx)(Masthead_1.Masthead, Object.assign({}, masthead)), children] })));
}
exports.Layout = Layout;
//# sourceMappingURL=Layout.js.map